export default {
  state: {
    access_token: '',
    refresh_token: '',
    name_ar: '',
    name_en: '',
    avatar_file_key: '',
    company_name_ar: '',
    company_name_en: '',
    user_type_code: '',
    user_group_type_code: '',
    user_status_type_code: '',
    ind_representative: '',
    agent_authorization_type_code: '',
    ind_update_cert: '',
    company_seq: null,
    user_seq: null
  },
  mutations: {
    SET_INIT_TOKEN: (state) => {
      state.access_token = ''
      state.refresh_token = ''
      state.name_ar = ''
      state.name_en = ''
      state.avatar_file_key = ''
      state.company_name_ar = ''
      state.company_name_en = ''
      state.user_type_code = ''
      state.user_group_type_code = ''
      state.user_status_type_code = ''
      state.ind_representative = ''
      state.agent_authorization_type_code = ''
      state.ind_update_cert = ''
      state.company_seq = null
      state.user_seq = null
    },
    SET_TOKEN: (state, token) => {
      state.access_token = token.access_token
      state.refresh_token = token.refresh_token
      state.name_ar = token.name_ar
      state.name_en = token.name_en
      state.avatar_file_key = token.avatar_file_key
      state.company_name_ar = token.company_name_ar
      state.company_name_en = token.company_name_en
      state.user_type_code = token.user_type_code
      state.user_group_type_code = token.user_group_type_code
      state.user_status_type_code = token.user_status_type_code
      state.ind_representative = token.ind_representative
      state.agent_authorization_type_code = token.agent_authorization_type_code
      state.ind_update_cert = token.ind_update_cert
      state.company_seq = token.company_seq
      state.user_seq = token.user_seq
    },
    SET_ACCESS_TOKEN: (state, token) => {
      state.access_token = token
    },
    SET_REFRESH_TOKEN: (state, token) => {
      state.refresh_token = token
    },
    SET_NAME_AR: (state, name) => {
      state.name_ar = name
    },
    SET_NAME_EN: (state, name) => {
      state.name_en = name
    },
    SET_COMPANY_NAME_AR: (state, name) => {
      state.company_name_ar = name
    },
    SET_COMPANY_NAME_EN: (state, name) => {
      state.company_name_en = name
    },
    SET_AVARTAR_FILE_KEY: (state, avatarFileKey) => {
      state.avatar_file_key = avatarFileKey
    },
    SET_USER_STATUS_TYPE_CODE: (state, userStatusTypeCode) => {
      state.user_status_type_code = userStatusTypeCode
    }
  },
  actions: {
    SetInitToken ({ commit }) {
      commit('SET_INIT_TOKEN')
    },
    SetToken ({ commit }, token) {
      commit('SET_TOKEN', token)
    },
    SetAccessToken ({ commit }, token) {
      commit('SET_ACCESS_TOKEN', token)
    },
    SetRefreshToken ({ commit }, token) {
      commit('SET_REFRESH_TOKEN', token)
    },
    SetNameAr ({ commit }, name) {
      commit('SET_NAME_AR', name)
    },
    SetNameEn ({ commit }, name) {
      commit('SET_NAME_EN', name)
    },
    SetCompanyNameAr ({ commit }, name) {
      commit('SET_COMPANY_NAME_AR', name)
    },
    SetCompanyNameEn ({ commit }, name) {
      commit('SET_COMPANY_NAME_EN', name)
    },
    SetAvatarFileKey ({ commit }, avatarFileKey) {
      commit('SET_AVARTAR_FILE_KEY', avatarFileKey)
    },
    SetUserStatusTypeCode ({ commit }, userStatusTypeCode) {
      commit('SET_USER_STATUS_TYPE_CODE', userStatusTypeCode)
    }
  }
}
